import {SliceStatus} from 'interfaces';

import {createReducer} from '@reduxjs/toolkit';

import {
  resetYouTubeState,
  signInYouTube,
  signInYouTubeFailure,
  signInYouTubeSuccess,
  signOutYouTube,
  signOutYouTubeFailure,
  signOutYouTubeSuccess,
  YouTubeSignInResponse,
} from './youtubeActions';
import {loadYouTubeAuth} from './youtubeUtils';

export interface YouTubeState {
  status: SliceStatus;
  isAuthenticated: boolean;
  accessToken: string | null;
  error: string | null;
}

const savedAuth: YouTubeSignInResponse | null = loadYouTubeAuth();

export const youtubeSliceInitialState: YouTubeState = {
  status: SliceStatus.idle,
  isAuthenticated: !!savedAuth,
  accessToken: savedAuth?.accessToken || null,
  error: null,
};

export const youtubeReducer = createReducer(
  youtubeSliceInitialState,
  builder => {
    builder
      .addCase(signInYouTube, state => {
        state.status = SliceStatus.pending;
        state.error = null;
      })
      .addCase(signInYouTubeSuccess, (state, action) => {
        state.status = SliceStatus.resolved;
        state.isAuthenticated = true;
        state.accessToken = action.payload.accessToken;
        state.error = null;
      })
      .addCase(signInYouTubeFailure, (state, action) => {
        state.status = SliceStatus.rejected;
        state.isAuthenticated = false;
        state.accessToken = null;
        state.error = action.payload;
      })
      .addCase(signOutYouTube, state => {
        state.status = SliceStatus.pending;
      })
      .addCase(signOutYouTubeSuccess, state => {
        state.status = SliceStatus.idle;
        state.isAuthenticated = false;
        state.accessToken = null;
        state.error = null;
      })
      .addCase(signOutYouTubeFailure, (state, action) => {
        state.status = SliceStatus.rejected;
        state.error = action.payload;
      })
      .addCase(resetYouTubeState, () => youtubeSliceInitialState);
  },
);

// Selectors
export const selectYouTube = (state: any): YouTubeState => state.youtube;

export const selectIsYouTubeAuthenticated = (state: any): boolean =>
  selectYouTube(state).isAuthenticated;

export const selectIsYouTubeAuthenticating = (state: any): boolean =>
  selectYouTube(state).status === SliceStatus.pending;
